import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './RMSidebar.css';

// Import icons from react-icons (assuming they are installed)
import { 
  FaHome,  
  FaCreditCard, 
  FaFileInvoice, 
  FaCog,
  FaUsersCog
} from 'react-icons/fa';

const RMSidebar = () => {
  const location = useLocation();
  const { getCurrentUser } = useAuth();
  const currentUser = getCurrentUser();

  // Define sidebar links with better icons
  const sidebarLinks = [
    { path: '/rm/home', label: 'Dashboard', icon: <FaHome size={18} /> },
    { path: '/rm/owners', label: 'Owners', icon: <FaUsersCog size={18} /> },
    { path: '/rm/leads', label: 'Leads', icon: <FaFileInvoice size={18} /> },
    { path: '/rm/payouts', label: 'Payouts', icon: <FaCreditCard size={18} /> },
    { path: '/rm/settings', label: 'Settings', icon: <FaCog size={18} /> },
  ];

  return (
    <div className="rm-sidebar">
      <div className="rm-sidebar-logo">
        <img src="/static/images/Wishfin-logo.png" alt="Wishfin" />
      </div>
      
      <div className="rm-sidebar-title">
        <h3>Relationship Manager</h3>
      </div>
      
      <nav className="rm-sidebar-nav">
        <ul>
          {sidebarLinks.map((link) => (
            <li 
              key={link.path} 
              className={location.pathname.startsWith(link.path) ? 'active' : ''}
            >
              <Link to={link.path}>
                <span className="rm-sidebar-icon">{link.icon}</span>
                <span className="rm-sidebar-label">{link.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      
      <div className="rm-sidebar-user-status">
        <div className="rm-sidebar-status">
          <div className="status-indicator online"></div>
          <span>Active</span>
        </div>
      </div>
    </div>
  );
};

export default RMSidebar;
